import axios from 'axios';

import routes from 'app/routes';

export default {
  loadCoaches: (programId, callback) => {
    axios
      .get(routes.api.members.chooseNewCoach(programId))
      .then((response) => {
        callback(response.data.data);
      });
  },
  saveCoach: (programId, coachId, callback) => {
    axios
      .post(routes.api.members.saveNewCoach(programId), {
        coach_id: coachId,
      })
      .then(() => {
        callback();
      });
  },

};
